import React, { useContext } from 'react';
import { useAnalytics as _useAnalytics } from '@libertify.frontend/analytics';
import { AppContext } from '../contexts/AppContext';
import {
  MediaAnalyticsEvents,
  MediaEventsWithProperties,
  ProjectType,
} from '../types';

export function useAnalytics(props?: {
  projectType?: ProjectType;
  projectId?: string;
  publicationId?: string;
  organizationId?: string;
  /**
   * Workspace owning the project. Only needed where the surface has no
   * provider-level `workspace_id` super property — media-player's experience
   * route sets one, admin (whose super properties are registered once at app
   * startup) has to pass it per event.
   */
  workspaceId?: string;
}) {
  const { identifiers } = useContext(AppContext);

  const projectType = props?.projectType || 'new_video';
  const projectId = props?.projectId || identifiers.projectId;
  const publicationId = props?.publicationId || identifiers.publicationId;
  const organizationId = props?.organizationId || identifiers.organizationId;
  const workspaceId = props?.workspaceId;

  const analyticsParams = React.useMemo(() => {
    const defaultParams = {
      publication_id: publicationId || undefined,
      project_id: projectId || undefined,
      project_type: projectType,
      organization_id: organizationId || undefined,
      workspace_id: workspaceId || undefined,
    };

    return Object.fromEntries(
      Object.entries(defaultParams).filter(([_, v]) => v !== undefined),
    );
  }, [publicationId, projectId, projectType, organizationId, workspaceId]);

  return _useAnalytics<MediaAnalyticsEvents, MediaEventsWithProperties>(
    analyticsParams,
  );
}
